/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { GET_PAYMENT_REPORT ,GET_PAYMENT_REPORT_STATUS} from '../../api/graphql';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { vappContainer } from '@/application';
import { Graphql } from '@common/graphql';
import { AppNavigatorService } from '@/AppNavigator';
import { apiConfig } from '@/config/apiConfig';
import { userListConfig } from '../../config/userLists.config';
import { APPLICATION_TYPE } from '@/config/applicationType.config';
import { APPLICATION_STATUS } from '@/config/applicationStatus.config';

const is = require("is_js");

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IPaymentTxnReportMethods extends IPluginMethodMap {
  getPaymentTxnReport(args: any): Promise<any>;
}

export class PaymentTxnReportService implements IAgentPlugin {
  readonly methods: IPaymentTxnReportMethods;
  private pollingTime = 10000;

  constructor() {
    this.methods = {
      getPaymentTxnReport: this.getPaymentTxnReport.bind(this),
    };
  }

  async getPaymentTxnReport(args: any) {
    console.log(`getPaymentTransactionReportProps args`, args);
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
  
      console.log('data in query sajn', args);

    try {
      if (client) {
        console.log('data in query sajn#1', args);
        let filters:any =[]
        if(args?.criteria?.startDate && args?.criteria?.endDate){
          filters=    [ {
            op: "MoreThanOrEqual",
            column: "paidOn",
            value: [args?.criteria?.startDate]
          },
            {
            op: "LessThan",
            column: "paidOn",
            value: [args?.criteria?.endDate]
          }]
        }
        const res = await client.query(GET_PAYMENT_REPORT, {
          input: {
            where: filters ?? [],
            limit: 100,
            skip:0,
          },
        });

        if (
          res?.data?.getPaymentReport?.jobId &&
          is.existy(res?.data?.getPaymentReport?.jobId)
        ) {
          return this.checkStatus(
            res?.data?.getPaymentReport?.jobId
          );
        } else {
          throw new Error("Some unexpected error occurred");
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
  private async checkStatus(jobId: string, retries = 25) {

    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
      
        const res = await client.query(GET_PAYMENT_REPORT_STATUS, {
       
            jobId: jobId,
          
        });
        console.log("RES123",res?.data)

      if (res?.data?.getPaymentReportStatus?.message === "success") {
        return res?.data?.getPaymentReportStatus;
      } else if (res?.data?.getPaymentReportStatus?.message === "generating report") {
        if (retries > 0) {
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              this.checkStatus(jobId, retries - 1)
                .then(resolve)
                .catch(reject);
            }, this.pollingTime || 10000);
          });
        } else {
          throw new Error("Exceeded retry limit for checking status");
        }
      } else {
        throw new Error("Some unexpected error occurred");
      }
    } 
  }catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
